import axios from "axios";


const otpUrl = process.env.REACT_APP_OTP_SERVICE_BASE_URL;

export const createOTP = async (reqBody: any) => 
    {
        // console.log("OTP received", reqBody)
        const res = await axios.post(otpUrl+'creation', reqBody)
        // console.log(res)
    }
export const validateOTP = (reqBody: any) => axios.post(otpUrl+'validation', reqBody);